/**
 * prebid-config.js
 * news.dupontregistry.com — Kargo/Prebid integration
 */

window.pbjs = window.pbjs || {};
window.pbjs.que = window.pbjs.que || [];
window.googletag = window.googletag || { cmd: [] };

(function () {
  'use strict';

  // ----------------------------------------------------------
  // Kargo Placement IDs mapped from the official spreadsheet
  // Handles Desktop vs Mobile viewport separation (< 768px)
  // ----------------------------------------------------------
  var KARGO_PLACEMENT_IDS = {
    'blog_728x90_top': {
      desktop: '_ei8gyKBxd1',
      mobile: '_stPxO6qOtp'
    },
    'blog_300x250_in_article': {
      desktop: '_nWz6jle3KC',
      mobile: '_xecp7V9VfX'
    }
    // 'blog_oop': '_REPLACE_ONCE_KARGO_PROVIDES_OOP_ID'
  };

  var BIDDER_TIMEOUT = 1200; // ms
  var MOBILE_BREAKPOINT = 768; // matches the sizeMapping breakpoint used elsewhere in the theme

  pbjs.que.push(function () {
    pbjs.setConfig({
      bidderTimeout: BIDDER_TIMEOUT,
      priceGranularity: 'medium'
    });

    pbjs.bidderSettings = {
      kargo: { storageAllowed: false } // ⚠️ still pending legal sign-off — see earlier note
    };
  });

  /**
   * Called by Liquid sections to request bids from Kargo before GPT display.
   *
   * @param {string} divId          - element id of the slot's div
   * @param {string} placementKey   - the placement_name value (e.g. 'blog_728x90_top')
   * @param {Array}  desktopSizes   - sizes array for desktop (>= MOBILE_BREAKPOINT)
   * @param {Array}  mobileSizes    - sizes array for mobile (< MOBILE_BREAKPOINT)
   */
  function requestBidsAndDisplay(divId, placementKey, desktopSizes, mobileSizes) {
    var rawConfig = KARGO_PLACEMENT_IDS[placementKey];

    if (!rawConfig) {
      // Fall back directly to GPT display if no Kargo ID exists for this key
      googletag.display(divId);
      return;
    }

    // ONE device check drives BOTH which placementId and which sizes we
    // send — keeping them locked together so a mobile placementId can
    // never go out paired with desktop-only sizes, or vice versa.

    var isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    var kargoPlacementId = rawConfig;
    var sizes = desktopSizes;
    if (typeof rawConfig === 'object' && rawConfig !== null) {
      kargoPlacementId = isMobile ? rawConfig.mobile : rawConfig.desktop;
      sizes = isMobile ? mobileSizes : desktopSizes;
    }

    if (!kargoPlacementId) {
      googletag.display(divId);
      return;
    }

    pbjs.que.push(function () {
      pbjs.addAdUnits([
        {
          code: divId,
          mediaTypes: { banner: { sizes: sizes } },
          bids: [{ bidder: 'kargo', params: { placementId: kargoPlacementId } }]
        }
      ]);

      pbjs.requestBids({
        adUnitCodes: [divId],
        bidsBackHandler: function () {
          pbjs.setTargetingForGPTAsync([divId]);
          googletag.display(divId);
        }
      });
    });
  }

  window.KargoPrebid = window.KargoPrebid || {};

  // Flush queued calls executed before this script finished loading
  var queuedCalls = window.KargoPrebid.queue || [];
  window.KargoPrebid.requestBidsAndDisplay = requestBidsAndDisplay;
  queuedCalls.forEach(function (args) {
    requestBidsAndDisplay.apply(null, args);
  });
})();